import { StakeDbDashboardRewardItem } from '@/types/stake-db';
import { Tables } from '../../pools/table/Tables';
import { GridColDef } from '@mui/x-data-grid';
import { StakeDbDashboardRewardColumns } from '../table/StakeDbColumnsData';
import { Button, Typography } from '@mui/material';
import { now } from '@/lib/dayjs';
import { fontWeight } from '@/theme';

export default function RewardList({ list }: { list: StakeDbDashboardRewardItem[] | undefined }) {
  if (!list) {
    return <>reward empty</>;
  }

  const columns: GridColDef[] = [
    ...StakeDbDashboardRewardColumns,
    {
      minWidth: 200,
      field: 'shortTxHash',
      headerName: 'hash',
      headerAlign: 'center',
      align: 'left',
      sortable: false,
      renderCell: (params) => (
        <Button color="primary" onClick={() => handleButtonClick(params.row.txHash)}>
          {params.row.shortTxHash}
        </Button>
      ),
    },
  ];

  const handleButtonClick = (aData: string) => {
    const src =
      process.env.NODE_ENV === 'development'
        ? `https://amoy.polygonscan.com/tx/${aData}`
        : `https://polygonscan.com/tx/${aData}`;
    window.open(src);
  };

  return (
    <>
      <Typography variant="h5" fontWeight={fontWeight.Bold} textAlign="left">
        Reward
      </Typography>
      <Tables list={list} columns={columns} csvName={`stake-db-reward-${now()}`} />
    </>
  );
}
